var _circle, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReadyToOrder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32.9141,
    cy: 32.3672,
    r: 32,
    fill: "#E6F4FD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.2448 31.0469C35.4705 31.0469 31.5859 34.9314 31.5859 39.7058C31.5859 44.4801 35.4705 48.3647 40.2448 48.3647C45.0192 48.3647 48.9037 44.4801 48.9037 39.7058C48.9037 34.9314 45.0192 31.0469 40.2448 31.0469ZM43.9975 38.0286L39.668 43.0241C39.4855 43.2333 39.2257 43.3585 38.9487 43.3678C38.9367 43.3678 38.9247 43.3678 38.9127 43.3678C38.6476 43.3678 38.3932 43.2626 38.2067 43.0747L35.8754 40.7435C35.4851 40.3532 35.4851 39.7204 35.8754 39.3301C36.2657 38.9398 36.8985 38.9398 37.2888 39.3301L38.8621 40.902L42.4882 36.7178C42.8492 36.3022 43.4793 36.2555 43.8976 36.6165C44.3132 36.9815 44.3585 37.6116 43.9975 38.0286Z",
    fill: "#2995DB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2186 16.3945L22.7444 16.4212C21.9052 16.4212 21.1192 16.8874 20.7196 17.6201L17.3359 23.7479L28.5659 23.7213L29.2186 16.3945Z",
    fill: "#2995DB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1547 23.6939L39.7311 17.5661C39.3181 16.8334 38.5455 16.3672 37.6929 16.3672L31.2188 16.3938L31.8981 23.7206L43.1547 23.6939Z",
    fill: "#2995DB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5779 28.8768C42.5256 28.5571 41.4066 28.3839 40.2476 28.3839C33.9999 28.3839 28.9244 33.4594 28.9244 39.7071C28.9244 40.8661 29.0976 41.9984 29.4306 43.0508L19.0799 43.0774C19.0666 43.0774 19.0666 43.0774 19.0666 43.0774C17.921 43.0774 16.9752 42.1316 16.9752 40.9726L16.9219 25.7463L29.2441 25.7197H31.2424L43.5646 25.6797L43.5779 28.8768Z",
    fill: "#2995DB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReadyToOrder);
export default __webpack_public_path__ + "static/media/Ready-to-Order.40dcaf3d8623b5f37be06502c63c34d4.svg";
export { ForwardRef as ReactComponent };